import {ProModal, ProModalProps} from 'Components/ProModal';
import ProForm from 'Components/ProForm';
import {Input, message} from 'antd';
import {RoleForm, saveRole} from '../../service';
import {errorMessage} from 'Utils/common';
import {SimpleSwitch} from 'Features/Fields/SimpleSwitch';

interface RoleModalProps extends ProModalProps {
    onOk(): void;
    initialValues?: RoleForm;
}

export function RoleModal({initialValues, onOk, ...props}: RoleModalProps) {
    async function onFinish(data: RoleForm) {
        try {
            await saveRole(data);
            message.success('保存成功!');
            onOk();
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    const action = initialValues ? 'edit' : 'add';
    const actionName = action === 'edit' ? '修改' : '新增';

    return (
        <ProModal.Form
            {...props}
            title={`${actionName}角色`}
            width={700}
            onFinish={onFinish}
            formProps={{
                columns: 1,
                labelCol: {offset: 2, span: 6},
                wrapperCol: {offset: 1, span: 12},
            }}
            initialValues={initialValues}>
            <ProForm.Field name="id" hidden>
                <Input />
            </ProForm.Field>

            <ProForm.Field
                name="roleName"
                required
                label="角色名称"
                rules={[{required: true, message: '请输入${label}'}]}>
                <Input placeholder={`请输入角色名称`} maxLength={150} />
            </ProForm.Field>

            <ProForm.Field
                name="code"
                required
                label="角色编码"
                rules={[
                    {required: true, message: '请输入${label}'},
                    {
                        pattern: /^[a-zA-Z0-9_]+$/,
                        message: '只能输入字母数字下划线',
                    },
                ]}>
                <Input
                    placeholder="请输入角色编码"
                    maxLength={150}
                    disabled={action === 'edit'}
                />
            </ProForm.Field>

            <ProForm.Field name="status" label="启用状态">
                <SimpleSwitch />
            </ProForm.Field>
        </ProModal.Form>
    );
}
